import { Role } from './../models/role.model.d';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from '../../core/http/http.service';
import { RoleApiUrls } from '../constants/role-api-url.constant';
import { PagedInput } from '../models/page-input.model';
import { PagedResult } from '../models/paged-result.model';
import { PageEvent } from '@angular/material/paginator';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private httpService: HttpService) { }

  getByUserNotInRole(userId: string): Observable<string[]> {
    return this.httpService.get(`${RoleApiUrls.notinrole}/${userId}`);
  }

  getRoles(search?: Role, pageData?: PagedInput): Observable<PagedResult<Role>> {
    const payload: any = {
      pageSize: pageData?.pageSize ?? 10,
      currentPage: pageData?.currentPage ?? 1,
      name: search?.name ?? null,
      active: search?.active ?? null,
      sortColumn: search?.sortColumn ?? 'dateCreated',
      sortDirection: search?.sortDirection ?? 'desc'
    };

    return this.httpService.post<PagedResult<Role>>(RoleApiUrls.roles, payload);
  }

  save(role: Role): Observable<boolean> {
    return this.httpService.post(RoleApiUrls.save, role);
  }

  getByUserRoles(): Observable<string[]> {
    return this.httpService.get<string[]>(RoleApiUrls.userroles);
  }

  getByRoleUser(roleName: string): Observable<User[]> {
    return this.httpService.get<User[]>(`${RoleApiUrls.usernotinrole}/${roleName}`);
  }
}
